export default __webpack_public_path__ + "static/media/saheb.2ee9dc24.png";